export enum Permission {
  ViewSkillsStack = 'View Skills Stack',
  CovidLearningLossProgram = 'Has Full Knowledge Assessment Report',
  QuickLearnAcceleratedMathProgram = 'Has Reduced Knowledge Assessment Report',
}
